
export default {
  data() {
    return {
      active: 0,
      gridmenu: [
        {
          url: "/rank/comprehensive",
          icon: "https://kuaitianyikao.oss-cn-hangzhou.aliyuncs.com/h5/static/svg/ic-rank-school-v2.svg",
          name: "大学竞争力排行榜",
          num: '746所',
        },
        {
          url: "/rank/alumni-association",
          icon: "https://kuaitianyikao.oss-cn-hangzhou.aliyuncs.com/h5/static/svg/ic-rank-xyh-v2.svg",
          name: "校友会大学排名",
          num: '940所',
        },
        {
          url: "/rank/default-rank",
          icon: "https://kuaitianyikao.oss-cn-hangzhou.aliyuncs.com/h5/static/svg/ic-rank-rk-v2.svg",
          name: "软科艺术类排名",
          num: '627所',
        },
        {
          url: "/rank/default-rank?type=ty",
          icon: "https://kuaitianyikao.oss-cn-hangzhou.aliyuncs.com/h5/static/svg/ic-rank-rk-v2.svg",
          name: "软科体育类排名",
          num: '268所',
        },
      ],
    };
  },
  methods: {
  },
};
